const trimEnv = (key: string): string | undefined => {
  const value = process.env[key]?.trim();
  return value || undefined;
};

/** Project API key from PostHog project settings (safe to expose in the browser). */
export const getPostHogKey = (): string | undefined =>
  trimEnv('REACT_APP_POSTHOG_KEY');

/** Ingestion host, e.g. https://us.i.posthog.com or https://eu.i.posthog.com */
export const getPostHogHost = (): string =>
  trimEnv('REACT_APP_POSTHOG_HOST') ?? 'https://us.i.posthog.com';

export const isPostHogEnabled = (): boolean => Boolean(getPostHogKey());

/** Stable slug for filters (shared PostHog projects). */
export const DEFAULT_POSTHOG_APP_SLUG = 'strat-edu';

/** Human-readable label shown in PostHog. */
export const DEFAULT_POSTHOG_APP_LABEL = 'Strat-Edu';

export const getPostHogAppSlug = (): string =>
  trimEnv('REACT_APP_POSTHOG_APP_SLUG') ?? DEFAULT_POSTHOG_APP_SLUG;

export const getPostHogAppLabel = (): string =>
  trimEnv('REACT_APP_POSTHOG_APP_LABEL') ?? DEFAULT_POSTHOG_APP_LABEL;

/** Registered on every event and person profile for this product. */
export const getPostHogSuperProperties = (): {
  app: string;
  app_label: string;
} => ({
  app: getPostHogAppSlug(),
  app_label: getPostHogAppLabel(),
});

export const posthogInitOptions = {
  api_host: getPostHogHost(),
  person_profiles: 'identified_only' as const,
  capture_pageview: 'history_change' as const,
  capture_pageleave: true,
};

/** Hosts to allow in CSP connect-src when PostHog is enabled. */
export const posthogConnectSrcHosts = (): string[] => {
  if (!isPostHogEnabled()) {
    return [];
  }
  const host = getPostHogHost().replace(/\/$/, '');
  const defaults = [
    'https://us.i.posthog.com',
    'https://eu.i.posthog.com',
    'https://us-assets.i.posthog.com',
    'https://eu-assets.i.posthog.com',
  ];
  return host && !defaults.includes(host) ? [...defaults, host] : defaults;
};
